var exports = {
  "kL": "VideoPlayer.module__container___MTA2Zz",
  "Ki": "VideoPlayer.module__video___MTA2Zz",
  "ER": "VideoPlayer.module__videoHidden___MTA2Zz",
  "mz": "VideoPlayer.module__seekPreviewVideo___MTA2Zz",
  "IN": "VideoPlayer.module__posterOverlay___MTA2Zz",
  "lW": "VideoPlayer.module__posterImage___MTA2Zz",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___MTA2Zz",
  "HT": "VideoPlayer.module__playOverlayButton___MTA2Zz",
  "$Z": "VideoPlayer.module__controlsOverlay___MTA2Zz",
  "hr": "VideoPlayer.module__progressBar___MTA2Zz",
  "xu": "VideoPlayer.module__controlsRow___MTA2Zz",
  "it": "VideoPlayer.module__controlsLeft___MTA2Zz",
  "QE": "VideoPlayer.module__controlsCenter___MTA2Zz",
  "BT": "VideoPlayer.module__controlsRight___MTA2Zz",
  "sL": "VideoPlayer.module__playPauseIndicator___MTA2Zz",
  "HA": "VideoPlayer.module__fillContainer___MTA2Zz",
  "Y5": "VideoPlayer.module__fullscreen___MTA2Zz",
};

module.exports = exports;
